export default "__VITE_ASSET__CjLpOwG$__"